import PropTypes from 'prop-types';
import { PureComponent } from 'react';
// -*- mode: jsx;-*-

export class ErrorMessage extends PureComponent {
    render() {
        const errorMessages = this.props.errorMessages;
        const fieldName = this.props.fieldName;
        if (errorMessages && errorMessages[fieldName] && errorMessages[fieldName].length) {
            const messages = this.props.errorMessages[fieldName];
            const messageText = messages.map((message, index) => {
                return (message.message);
            });
            if (messageText && messageText.length > 0) {
                if (this.props.hideErrorClass) {
                    return (
                        <p>{messageText.join(' ')}</p>
                    );
                } else {
                    return (
                        <div className="error-text" dangerouslySetInnerHTML={{ __html: messageText.join(' ') }} />
                    );
                }
            } else {
                return null;
            }
        }
        return null;
    }
}
ErrorMessage.propTypes = {
    errorMessages: PropTypes.object,
    fieldName: PropTypes.string,
    hideErrorClass: PropTypes.bool,
};

ErrorMessage.defaultProps = {
    hideErrorClass: false,
};
